<template>
  <v-container>
    <v-layout>
      <v-flex>
        <span v-if="currentUser">{{currentUser.fullName}}</span>
        <p>Add Participants</p>
        <p>Add indicators</p>
        <p>Manage users</p>
        <p>Shuffle cards</p>
        <p>Challenge a troll to a duel</p>
        <score-gauge value="30" color="green" trendMin="20" trendMax="40" trendAverage="37.5"></score-gauge>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<style scoped>
</style>

<script>
import ScoreGauge from "@/components/ScoreGauge.vue";

export default {
  components: {
    ScoreGauge
  },
  computed: {
    currentUser() {
      return this.$store.state.currentUser;
    },
  },
  methods: {},
};
</script>